module.exports = __webpack_public_path__ + "static/orgbiochem_logo-1a1050df930a79c2edc2813589314093.svg";